import React, { useEffect, useState } from 'react';

const AdminContentPanel = ({ onClose }) => {
  const [blogPosts, setBlogPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('posts');

  useEffect(() => {
    fetchBlogPosts();
  }, []);

  const fetchBlogPosts = async () => {
    setLoading(true);
    try {
      // Get blog posts from localStorage (since we're using localStorage for blog data)
      const savedPosts = localStorage.getItem('blogArticles');
      if (savedPosts) {
        setBlogPosts(JSON.parse(savedPosts));
      } else {
        // Default posts if none saved
        setBlogPosts([
          {
            id: 1,
            title: "10 Essential Car Maintenance Tips",
            slug: "10-essential-car-maintenance-tips",
            date: "2024-01-15",
            status: "published"
          },
          {
            id: 2,
            title: "How to Change Your Oil",
            slug: "how-to-change-your-oil",
            date: "2024-01-10",
            status: "published"
          }
        ]);
      }
    } catch (error) {
      console.error('Error fetching blog posts:', error);
    }
    setLoading(false);
  };

  const handleEditPost = (post) => {
    alert(`Edit Post: ${post.title}\nThis would open the blog post editor.`);
  };

  const handleDeletePost = (post) => {
    if (window.confirm(`Are you sure you want to delete "${post.title}"?`)) {
      const updatedPosts = blogPosts.filter(p => p.id !== post.id);
      setBlogPosts(updatedPosts);
      localStorage.setItem('blogArticles', JSON.stringify(updatedPosts));
    }
  };

  const handleCreatePost = () => {
    alert('Create New Post: This would open the blog post creation form.');
  };

  return (
    <div className="admin-content-panel">
      <div className="admin-panel-header">
        <h3>Content Management</h3>
        <button className="close-btn" onClick={onClose}>
          <i className="fas fa-times"></i>
        </button>
      </div>

      <div className="admin-panel-tabs">
        <button 
          className={`tab-btn ${activeTab === 'posts' ? 'active' : ''}`}
          onClick={() => setActiveTab('posts')}
        >
          <i className="fas fa-newspaper"></i>
          Blog Posts
        </button>
        <button 
          className={`tab-btn ${activeTab === 'pages' ? 'active' : ''}`}
          onClick={() => setActiveTab('pages')}
        >
          <i className="fas fa-file-alt"></i>
          Pages
        </button>
      </div>

      <div className="admin-panel-content">
        {activeTab === 'posts' && (
          <div className="posts-section">
            <div className="section-header">
              <h4>Blog Posts ({blogPosts.length})</h4>
              <button className="create-btn" onClick={handleCreatePost}>
                <i className="fas fa-plus"></i>
                Create Post
              </button>
            </div>

            {loading ? (
              <div className="loading">Loading posts...</div>
            ) : (
              <div className="posts-list">
                {blogPosts.map(post => (
                  <div key={post.id} className="post-item">
                    <div className="post-info">
                      <h5>{post.title}</h5>
                      <p>Slug: {post.slug} | Date: {post.date}</p>
                    </div>
                    <div className="post-actions">
                      <button 
                        className="edit-btn"
                        onClick={() => handleEditPost(post)}
                      >
                        <i className="fas fa-edit"></i>
                      </button>
                      <button 
                        className="delete-btn"
                        onClick={() => handleDeletePost(post)}
                      >
                        <i className="fas fa-trash"></i>
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {activeTab === 'pages' && (
          <div className="pages-section">
            <h4>Website Pages</h4>
            <div className="pages-list">
              <div className="page-item">
                <span>Home Page</span>
                <button className="edit-btn">Edit</button>
              </div>
              <div className="page-item">
                <span>Features Page</span>
                <button className="edit-btn">Edit</button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminContentPanel;
